export default "__VITE_ASSET__3a41991d__"